import { atom, selector } from "recoil";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const customerInfoListState = atom({
    key: 'customerInfoListState',
    default: [],
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const filtersDefault = []

// View and delete only: staff review submissions and create cases from them.
export const formModes = {
    create: [],
    update: [],
    view: [ { name: 'Default View' } ],
}

export const TRAVELER_TYPE_LABELS = { TOURIST: 'Tourist', MALDIVIAN: 'Maldivian', WORK_VISA: 'Work Visa Holder' }
export const METHOD_LABELS = { PHONE: 'Phone', EMAIL: 'Email', WHATSAPP: 'WhatsApp', TELEGRAM: 'Telegram', VIBER: 'Viber' }

/** Adds display-only fields the grid and view modal read. */
export const withDisplayFields = (row) => ({
    ...row,
    traveler_type_label: TRAVELER_TYPE_LABELS[row.traveler_type] || row.traveler_type,
    contact_methods_text: (row.contact_methods || []).map(m => METHOD_LABELS[m] || m).join(', '),
    status_label: row.status === 'CONVERTED' ? `Case ${row.case_file?.primary_reference || row.case_file?.reference || ''}`.trim() : 'New',
})

const readOnly = (label, field, order, extra = {}) => ({
    label,
    field,
    type: 'text',
    order: { form: order, ...(extra.table ? { table: extra.table } : {}) },
    update: [{ enabled: false }],
    view: [{ enabled: true, size: { xs: 12, md: 6 } }, { enabled: false }],
    create: [{ enabled: false }],
})

export const customerInfoDataStructureState = selector({
    key: 'customerInfoDataStructureState',
    get: ({ get }) => (
        [
            readOnly('Reference', 'reference', 1, { table: 1 }),
            readOnly('Full Name', 'full_name', 2, { table: 2 }),
            readOnly('Arrival Flight', 'arrival_flight', 3, { table: 3 }),
            readOnly('Arrival Date', 'arrival_date', 4, { table: 4 }),
            readOnly('Traveler Type', 'traveler_type_label', 5, { table: 5 }),
            readOnly('Place of Stay', 'place_of_stay', 6),
            readOnly('Hotel Contact', 'hotel_contact', 7),
            readOnly('Return Flight', 'return_flight', 8),
            readOnly('Return Date', 'return_date', 9),
            readOnly('Address', 'address', 10),
            readOnly('Road', 'road', 11),
            readOnly('Zip', 'zip', 12),
            readOnly('City', 'city', 13),
            readOnly('Country', 'country', 14),
            readOnly('Email', 'email', 15, { table: 6 }),
            readOnly('Mobile', 'mobile', 16, { table: 7 }),
            readOnly('Contact Methods', 'contact_methods_text', 17),
            readOnly('Status', 'status_label', 18, { table: 8 }),
        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
